export default "__VITE_ASSET__Do6bJ3Ae__"